import { useTranslation } from "react-i18next";
import DatePicker from "../../components/SingleDatePicker/SingleDatePicker";
import TimeRangeComponent from "../Timesheet/Daily/TimeRangeComponent";
import {
  CommonFlex,
  CommonGrid,
  CommonText,
  FormAlert,
  InputLabel,
  InputWithLabelSection,
  RedStar,
} from "../../styledComponents/common";
import { CheckboxDiv, CheckboxTickIcon } from "../../styledComponents/settings";
import {
  DurationContainer,
  DurationText,
} from "../ShiftSchedule/CreateShift/createShiftStyles";
import { TimeRangeSection } from "../Jobs/CreateJob/createTaskStyles";
import tickWhite from "../../assets/img/icons/tick_2.svg";
import durationIcon from "../../assets/img/icons/clock-in-duration.svg";

const JobStartTimeSection = ({setStartTime, setEndTime, startDate, onDateChange, isAnyTimeSet, handleAnytimeToggle, startTime, endTime, saveErrors, getJobDurationText, scrollTime, handleStartTime, handleEndTime, orgType, isRecurringDisabled}) => {
  const { t } = useTranslation();
  
  // Generate labels based on orgType
  const isOperationType = orgType === "operation";
  const itemStartDateLabel = isOperationType
    ? t("task_start_date")
    : t("job_start_date");
  const itemDurationLabel = isOperationType
    ? t("task_duration")
    : t("job_duration");

  return (
    <CommonFlex
                responsiveBreakpoint="600px"
                alignItems="start"
                flexFlow="row wrap"
                gap="32px"
                
              >
                <CommonGrid disableResponsive gap="7px" columns="1fr">
                  <InputWithLabelSection>
                    <InputLabel>
                      {itemStartDateLabel}
                      <RedStar>*</RedStar>
                    </InputLabel>
                    <DatePicker
                      id="createIssuedDate"
                      date={startDate}
                      onDateChange={onDateChange}
                      placeholder={"Select date"}
                      disabled={isRecurringDisabled}
                    />
                  </InputWithLabelSection>
                  <CommonFlex disableResponsive>
                    <CheckboxDiv
                      active={isAnyTimeSet}
                      onClick={isRecurringDisabled ? undefined : handleAnytimeToggle}
                      style={{
                        opacity: isRecurringDisabled ? 0.6 : 1,
                        cursor: isRecurringDisabled ? "not-allowed" : "pointer",
                        pointerEvents: isRecurringDisabled ? "none" : "auto",
                      }}
                    >
                      <CheckboxTickIcon src={tickWhite} alt="" />
                    </CheckboxDiv>
                    <CommonText color="#353A46" fontSize="14px" $label fontWeight="500">
                      Anytime this day
                    </CommonText>
                  </CommonFlex>
                </CommonGrid>
                <InputWithLabelSection ref={scrollTime}>
                  <TimeRangeSection style={{ gap: "28px" }}>
                    <InputLabel>
                      {t("start_time")}
                      <RedStar>*</RedStar>
                    </InputLabel>
                    <InputLabel>
                      {t("end_time")}
                      <RedStar>*</RedStar>
                    </InputLabel>
                  </TimeRangeSection>
                  <div
                    style={{
                      pointerEvents: isAnyTimeSet ? "none" : "auto",
                      opacity: isAnyTimeSet ? 0.5 : 1,
                      width: "100%",
                    }}
                  >
                    <TimeRangeComponent
                      setStartTime={handleStartTime}
                      setEndTime={handleEndTime}
                      initialStartTime={
                        startTime &&
                        startTime.includes(":") &&
                        startTime.length >= 5
                          ? startTime.substring(0, 5) // Extract "HH:mm" from "HH:mm:ss"
                          : undefined
                      }
                      initialEndTime={
                        endTime && endTime.includes(":") && endTime.length >= 5
                          ? endTime.substring(0, 5) // Extract "HH:mm" from "HH:mm:ss"
                          : undefined
                      }
                      startTimeError={
                        saveErrors &&
                        saveErrors["timeDifference"] !== undefined &&
                        saveErrors["timeDifference"] &&
                        saveErrors["timeDifference"]
                      }
                      endTimeError={
                        saveErrors &&
                        saveErrors["timeDifference"] !== undefined &&
                        saveErrors["timeDifference"] &&
                        saveErrors["timeDifference"]
                      }
                    />
                  </div>
                  {saveErrors &&
                    saveErrors["timeDifference"] &&
                    saveErrors["timeDifference"] !== undefined && (
                      <FormAlert>{saveErrors["timeDifference"]}</FormAlert>
                    )}
                  {!isAnyTimeSet && (
                    <DurationContainer style={{ margin: "0px 0 10px 0" }}>
                      <DurationText
                        style={{ display: "flex", alignItems: "center" }}
                        color="#353A46"
                      >
                        <img
                          src={durationIcon}
                          alt="duration icon"
                          width="15px"
                        />{" "}
                        {itemDurationLabel}: {getJobDurationText()}
                      </DurationText>
                    </DurationContainer>
                  )}
                </InputWithLabelSection>
              </CommonFlex>
  );

}

export default JobStartTimeSection;